import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "fill-current"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M14.0007 1.33334H2.00065C1.82384 1.33334 1.65427 1.40358 1.52925 1.52861C1.40422 1.65363 1.33398 1.8232 1.33398 2.00001V14C1.33398 14.1768 1.40422 14.3464 1.52925 14.4714C1.65427 14.5964 1.82384 14.6667 2.00065 14.6667H14.0007C14.1775 14.6667 14.347 14.5964 14.4721 14.4714C14.5971 14.3464 14.6673 14.1768 14.6673 14V2.00001C14.6673 1.8232 14.5971 1.65363 14.4721 1.52861C14.347 1.40358 14.1775 1.33334 14.0007 1.33334ZM7.33398 13.3333H2.66732V10.6667H7.33398V13.3333ZM7.33398 9.33334H2.66732V6.66668H7.33398V9.33334ZM13.334 13.3333H8.66732V10.6667H13.334V13.3333ZM13.334 9.33334H8.66732V6.66668H13.334V9.33334ZM13.334 5.33334H2.66732V2.66668H13.334V5.33334Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }